import _ from 'lodash'
import { CountUp } from "countup.js"
import Splide from '@splidejs/splide'

import "@fortawesome/fontawesome-free/css/fontawesome.css";
import "@fortawesome/fontawesome-free/css/solid.css";

const handleOnClick = (e) => {
	const nav = e.target

	if (window.innerWidth <= 1280) {
		nav.classList.toggle('mobile-clicked')
	}
}

const createCountupInstance = (el) => {
	const span = document.createElement('span')
	span.innerHTML = el.getAttribute('data-start')
	el.prepend(span)

	const countupInstance = new CountUp(span, el.getAttribute('data-end'), {
		startVal: el.getAttribute('data-start'),
		enableScrollSpy: true,
		scrollSpyDelay: 2000
	})

	const checkPosition = () => {
		const rect = el.getBoundingClientRect()
		const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight)
		if (!(rect.bottom < 0 || rect.top - viewHeight >= 0)) {
			window.setTimeout(countupInstance.start, 2000)
		}
	}

	window.addEventListener('scroll', _.debounce(checkPosition), 100)
	checkPosition()
}

window.addEventListener('load', () => {
	const nav = document.querySelector('nav')

	if (nav) {
		nav.addEventListener('click', handleOnClick)
	}

	const countupEls = document.querySelectorAll('.countup')
	countupEls.forEach(createCountupInstance)

	new Splide('.splide', {
		type: 'loop'
	}).mount()
})
